<template>
	<div class="h-panel-body padding font-bold">
		<template v-for="year in years">
			<h2 class="margin-bottom">{{year}}年</h2>
      <!-- 期末结转月份列表展示区域 -->
      <!-- 使用 Row 组件创建弹性布局，设置间距为 20 -->
			<Row :space="20">
        <!-- 遍历指定年份下的所有月份数据 -->
        <!-- v-for: 循环渲染每个月份单元格 -->
        <!-- :key: 使用年份 + 月份作为唯一标识，确保列表高效更新 -->
        <!-- width="3": 设置每个单元格的宽度为 3 个栅格单位 -->
        <Cell v-for="month in dataList[year]" :key="year+month.checkMonth" width="3">
          <!-- 月份展示卡片容器 -->
          <!-- :class: 动态绑定样式类名 -->
          <!--   - disable: 当 month.disable 为 true 时禁用样式 -->
          <!--   - completed: 当 month.status 等于 2 时显示已完成样式（带锁图标） -->
          <!-- @click: 点击事件，触发 carryForward 方法进行结转操作，传递当前月份数据对象 -->
          <div class="period" :class="{disable:month.disable,completed:month.status==2}" @click="carryForward(month)">
            <!-- 月份卡片头部背景区域 -->
            <!-- bg-primary-color: 应用主题背景色 -->
            <div class="bg-primary-color month-header">
              <!-- 已结账状态图标 -->
              <!-- v-if: 仅当月份状态为 2（已结账）时显示锁图标 -->
              <!-- fa-lock: Font Awesome 锁定图标 -->
              <!-- white-color: 白色图标颜色 -->
							<i v-if="month.status==2" class="fa fa-lock white-color"></i>
						</div>
            <!-- 显示月份数字 -->
            <!-- {{month.checkMonth}}月: 显示月份数值并添加"月"字后缀 -->
						{{month.checkMonth}}月
					</div>
				</Cell>
			</Row>
		</template>
	</div>
</template>

<script>
/**
 * 检查列表
 */
	export default {
		name: "CheckList",
		data() {
			return {
        // 存储检查数据的对象，键为年份，值为该年的月份数据数组
				dataList: {}
			}
		},
		computed: {
			years() {
				return Object.keys(this.dataList).sort((a, b) => b - a);
			}
		},
		methods: {

      /**
       * 加载会计期间列表数据
       *
       * 该方法从后端获取会计期间数据，并进行以下处理：
       * 1. 标记不可用的期间：如果某个期间的状态为 0（未结账），则其后的所有期间都标记为不可用
       * 2. 按年份分组：将获取到的期间数据按年度进行分组整理
       * 3. 更新组件数据：将处理后的数据存储到组件的 dataList 中供模板使用
       *
       * @returns {void} 无返回值，通过 this.dataList 更新组件状态
       */
			loadList() {
        // 调用后端 API 获取会计期间列表数据
				this.$api.checkout.list().then(({data}) => {
          // 禁用状态标识，用于标记是否存在未结账的期间
          // 初始值为 false，表示默认所有期间都可用
					let disable = false;
          // 倒序遍历数据数组，从最后一个期间向前检查
          // 目的：确保未结账期间之后的所有期间都被标记为不可用
					for (let i = data.length - 1; i >= 0; i--) {
            // 为当前期间设置禁用状态
						data[i].disable = disable;
            // 检查当前期间的结账状态
            // status === 0 表示该期间未结账
						if (data[i].status === 0) {
                  // 如果当前期间未结账，将 disable 设为 true
							disable = true;
						}
					}
          // 创建按年份分组的数据对象
          // key: 年度（checkYear）
          // value: 该年度下的所有期间数组
					let checkData = {};
          // 遍历数据数组，按年份进行分组
					data.forEach(val => {
            // 如果当前年份尚未在 checkData 中创建数组，则先初始化
						if (!checkData[val.checkYear]) {
							checkData[val.checkYear] = [];
						}
            // 将当前期间数据添加到对应年份的数组中
						checkData[val.checkYear].push(val);
					});

          // 将分组后的数据赋值给组件的 dataList 属性
          // 模板中的 v-for 循环会使用此数据进行渲染
					this.dataList = checkData;
				})
			},

      /**
       * 处理期间结转操作
       *
       * 根据传入的期间数据对象，判断是否允许进行期末结转操作。
       * 只有在期间状态为未结账（status=0）且未被禁用（disable=false）时，
       * 才允许跳转到结转页面进行操作。
       *
       * @param {Object} data - 会计期间数据对象
       * @param {number} data.status - 期间结账状态码
       *   - 0: 未结账
       *   - 1: 结转中
       *   - 2: 已结账
       * @param {boolean} data.disable - 期间是否被禁用
       *   - true: 禁用状态，不可点击
       *   - false: 启用状态，可以点击
       * @param {string} data.checkYear - 结账年度
       * @param {number} data.checkMonth - 结账月份
       * @returns {void} 无返回值，根据条件执行路由跳转或显示提示信息
       */
			carryForward(data) {
        // 判断期间是否可以点击结转
        // 条件：期间状态为未结账（0）且未被禁用
				if (data.status === 0 && !data.disable) {
          // 跳转到期末结转页面，传递期间数据作为参数
          // name: 'CarryForward' - 路由名称，对应期末结转组件
          // params: data - 将期间数据传递给目标页面
					this.$router.push({name: 'CarryForward', params: data})
				}
        // 判断期间是否被禁用
        else if (data.disable) {
          // 显示错误提示信息
          // 原因：存在上期未结转损益的情况，本期不能进行操作
					this.$Message("上期未结转，本期不能点击")
				}
			}
		},
		mounted() {
			this.loadList();
		}
	}
</script>


<style lang="less" scoped>
	.h-row > div > div {
		padding: 8px;
		border-radius: 5px;
		text-align: center;
		font-size: 20px;
		color: #000;
	}

	.period {
		border-radius: 3px;
		text-align: center;
		line-height: 54px;
		border: 1px solid @primary-color;
		white-space: nowrap;
		overflow: hidden;
		box-sizing: border-box;
		height: 80px;

		&:hover {
			cursor: pointer;
			box-shadow: 0 0 20px 2px rgba(102, 100, 100, 0.24), 0px 2px 4px 0px rgba(199, 198, 198, 0.5);
		}

		.month-header {
			height: 25px;
			margin: -8px -8px 0 -8px;
		}

		&.completed {
			.month-header {
				background-color: @gray1-color !important;
				line-height: 20px;
			}

			border-color: @gray1-color;

			color: #a2a2a2;

			&:hover {
				cursor: default;
				box-shadow: none;
			}
		}

		&.disable {
			opacity: 0.4;

			&:hover {
				cursor: default;
				box-shadow: none;
			}
		}
	}
</style>
